import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import mitt from 'mitt'
import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueTelInput)
  .mount('#app')


export const Eventbus = mitt()